import GalleryPage from "./../components/Gallery/Gallery";


export const commonRoutes: any = [
	// TODO: This POC will be removed later
	{ key: "Gallery Page", path: "/*", element: GalleryPage, protected: true }
];
